import e from"styled-components";const t=e.div`
	display: flex;
	background: ${({theme:e})=>e.bg.primary};
	padding: 4px;
	border-radius: 8px;
	border: 1px solid ${({theme:e})=>e.border.black10};
`,r=e.div`
	flex: 1;
	text-align: center;
	padding: 8px 16px;
	border-radius: 8px;
	font-family: 'PP Formula';
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: 20px;
	cursor: pointer;
	transition: all 0.3s ease;
	background: ${({isSelected:e,theme:t})=>e?t.text.title:"transparent"};
	color: ${({isSelected:e,theme:t})=>e?t.text.inverse:"#666"};
`;export{r as Tab,t as TabsWrapper};
